import {inject, injectable} from "inversify";
import {EventEmitter} from "@/modules/base/events";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";
import {Team} from "@/modules/team/entity";
import {GateTypeEnum} from "@/modules/action-points/enums";
import GateManager from "@/modules/action-points/services/GateManager";
import BeforeCurrencyExchangeEvent from "@/modules/action-points/ events/BeforeCurrencyExchangeEvent";
import AfterCurrencyExchangeEvent from "@/modules/action-points/ events/AfterCurrencyExchangeEvent";

@injectable()
export default class CoinsCurrencyExchanger {
  constructor(
    @inject(EventEmitter) private em: EventEmitter,
    @inject(ConfigRepository) private configRepository: ConfigRepository,
    @inject(GateManager) private gateManager: GateManager,
  ) {
  }

  public async exchange(team: Team, coins: number, type: GateTypeEnum) {
    const currencyGain = this.configRepository.get('currency.coinsExchangeRate')(type, coins);

    await this.em.emitAsync(new BeforeCurrencyExchangeEvent(team, type, currencyGain, coins));

    await this.gateManager.getGate(GateTypeEnum.COINS).currency.subtract(coins);
    await this.gateManager.getGate(type).currency.add(currencyGain);

    await this.em.emitAsync(new AfterCurrencyExchangeEvent(team, type, currencyGain, coins));
  }
}
